import {
  Button,
  Card,
  EButtonColorVariant,
  ECardMediaSize,
  EHeadingStyleVariant,
  ELoaderSize,
  Heading,
  Loader,
  Text,
} from '@outdoorsyco/bonfire';
import React, { useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { IFullUserInfo } from '@/services/types/user/user';

import { CoverPhotoMenuButton } from './CoverPhotoMenuButton/CoverPhotoMenuButton';

interface ICoverPhotoProps {
  userData: IFullUserInfo;
  isLoading: boolean;
  refetchUser: () => void;
}

export const CoverPhoto = ({ userData, isLoading, refetchUser }: ICoverPhotoProps) => {
  const intl = useIntl();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [showCoverPhotoPopover, setShowCoverPhotoPopover] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const handleClick = () => {
    if (inputRef?.current) {
      inputRef.current.click();
    }
  };

  return (
    <div>
      <Heading variant={EHeadingStyleVariant.H6} className="mb-4">
        <FormattedMessage defaultMessage="Cover photo" id="j1qOou" />
      </Heading>
      {userData.profile.mast_image_url ? (
        <Text className="mt-2 mb-4 text-secondary-base">
          <FormattedMessage
            defaultMessage="This is the primary background image displayed on your profile."
            id="ZYOxd9"
          />
        </Text>
      ) : (
        <Text className="mt-2 mb-4 text-secondary-base">
          <FormattedMessage
            defaultMessage="Please upload a cover photo, which will be the primary background image displayed on your profile."
            id="jcPcH4"
          />
        </Text>
      )}
      <div
        onMouseEnter={() => !isLoading && !isUploading && setShowCoverPhotoPopover(true)}
        onMouseLeave={() => setShowCoverPhotoPopover(false)}
        className={`${isLoading || isUploading ? 'pointer-events-none' : ''} relative origin-top-left`}
        aria-label={intl.formatMessage({
          defaultMessage: 'Upload cover photo area',
          id: 'CAGTXM',
        })}>
        {userData.profile.mast_image_url ? (
          <>
            <Card withBoxShadow={false} showHoverEffect={false}>
              <Card.Media
                image={userData.profile.mast_image_url}
                fullRadius
                size={ECardMediaSize.Full}
                className="aspect-[16/9]"
              />
            </Card>
            {isUploading && (
              <div>
                <div className="absolute top-0 w-full h-full bg-white opacity-60" />
                <Loader
                  className="absolute top-0 bottom-0 left-0 right-0 m-auto"
                  size={ELoaderSize.Medium}
                />
              </div>
            )}
          </>
        ) : (
          <Button
            label={intl.formatMessage({
              defaultMessage: 'Upload',
              id: 'p4N05H',
            })}
            onClick={handleClick}
            variant={EButtonColorVariant.Secondary}
            loading={isUploading}
          />
        )}

        <CoverPhotoMenuButton
          userData={userData}
          showPopover={showCoverPhotoPopover}
          inputRef={inputRef}
          loading={isLoading}
          handleClick={handleClick}
          refetchUser={refetchUser}
          setIsUploading={setIsUploading}
        />
      </div>
    </div>
  );
};
